export default {"src":"https://fishbrain.com/_next/static/media/alaska.6ab3e46f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};